import { makeVar } from "@apollo/client";

/**
 * Whether this tab's session has been replaced by another tab's.
 *
 * One-way. Nothing sets this back to `false`, because nothing can undo the
 * replacement — the shared cookie now belongs to whichever tab claimed it, and
 * a later request succeeding only means it succeeded as somebody else.
 */
export const sessionExpiredVar = makeVar(false);

export function markSessionExpired() {
  sessionExpiredVar(true);
}
